import React from 'react';
import { useNavigationStore } from '../store';
import NavGroup from './NavGroup';
import { useAuthorization } from '@/features/auth/hooks';
import styles from './NavigationMenu.module.css';

interface NavigationMenuProps {
  isMobile?: boolean;
}

export const NavigationMenu: React.FC<NavigationMenuProps> = ({ isMobile = false }) => {
  const { items, sidebarCollapsed } = useNavigationStore();
  const { filterNavigationItems } = useAuthorization();
  const isCollapsed = isMobile ? false : sidebarCollapsed;
  const visibleItems = filterNavigationItems(items);

  // In a real app, we might group items by category
  // For now, we'll put everything in a main group
  return (
    <nav className={styles.nav}>
      <NavGroup 
        items={visibleItems} 
        isCollapsed={isCollapsed} 
      />
    </nav>
  );
};

export default NavigationMenu;
